import { render, staticRenderFns } from "./RafflePrizesComponentView.vue?vue&type=template&id=d68251bc&scoped=true"
import script from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
export * from "./RafflePrizesComponentView.vue?vue&type=script&lang=js"
import style0 from "./RafflePrizesComponentView.vue?vue&type=style&index=0&id=d68251bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68251bc",
  null
  
)

export default component.exports